// SPDX-FileCopyrightText: 2023 Kevin Nguyen <kevin@sequentech.io>
//
// SPDX-License-Identifier: AGPL-3.0-only
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import styled from "@emotion/styled";
var StyledLink = styled.span(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    a.link {\n        text-decoration: underline;\n        font-weight: normal;\n        color: black;\n    }\n\n    a.link:hover {\n        text-decoration: none;\n    }\n"], ["\n    a.link {\n        text-decoration: underline;\n        font-weight: normal;\n        color: black;\n    }\n\n    a.link:hover {\n        text-decoration: none;\n    }\n"])));
export default StyledLink;
var templateObject_1;
